import { useEffect, useState } from 'react';
import SEOHead from '../../components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#organization`,
        "name": "Renoboys",
        "url": siteUrl,
        "logo": "https://static.readdy.ai/image/d18859bc617732e326735d9a6df55c85/c47b878513e2a65a8f9d3908d74616b3.png",
        "image": `${siteUrl}/og-image.jpg`,
        "description": "Renoboys offers professional home renovation and building services in Kingsland, servicing Auckland region wide. Quality renovations you can see, renos you can trust.",
        "telephone": "021 086 21239",
        "email": "info@renoboys.co.nz",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Kingsland",
          "addressRegion": "Auckland",
          "addressCountry": "NZ"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "-36.8688",
          "longitude": "174.7492"
        },
        "areaServed": {
          "@type": "City",
          "name": "Auckland"
        },
        "priceRange": "$$",
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "17:00"
          }
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "Renoboys",
        "description": "Professional home renovation and building services in Auckland",
        "publisher": {
          "@id": `${siteUrl}/#organization`
        }
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        "url": siteUrl,
        "name": "Renoboys Auckland | Kingsland Renovation Services",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${siteUrl}/#organization`
        },
        "description": "Renoboys offers professional home renovation and building services in Kingsland, servicing Auckland region wide. Quality renovations you can see, renos you can trust. Contact us for a free consultation at 021 086 21239."
      },
      {
        "@type": "Service",
        "serviceType": "Home Renovation and Building",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": {
          "@type": "City",
          "name": "Auckland"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Renovation and Building Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Kitchen Renovations",
                "description": "Professional kitchen renovation services in Auckland"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Bathroom Renovations",
                "description": "Expert bathroom renovation services in Kingsland and Auckland"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Full Home Renovations",
                "description": "Complete home renovation solutions across Auckland region"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Deck Building",
                "description": "Professional deck construction and renovation services"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Home Building",
                "description": "Quality home building services in Auckland"
              }
            }
          ]
        }
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Renoboys Auckland | Kingsland Renovation Services"
        description="Renoboys offers professional home renovation and building services in Kingsland, servicing Auckland region wide. Quality renovations you can see, renos you can trust. Contact us for a free consultation at 021 086 21239."
        keywords="renovation services, Kingsland renovations, Auckland renovations, home renovation, Renoboys, home building, home builder, bathroom renovation, deck"
        canonical="/"
        schema={schema}
      />
      {/* <WelcomeModal /> */}
      <div className="min-h-screen bg-white">
        <Header scrolled={scrolled} />
        <Hero />
        <Services />
        <Gallery />
        <About />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </>
  );
}